/**
 * Overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 *
 * ALERON replaces Horizon's <theme-drawer id="cart-drawer"> with
 * <aleron-cart id="cart-drawer">, so these look the drawer up by id and
 * check for an open() method rather than matching on the element name.
 * Without that, anything calling Shopify.actions.openCart — apps, and
 * Shopify's own standard-events bundle — would navigate to /cart instead of
 * opening the drawer.
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.getElementById('cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.getElementById('cart-drawer');

      // A custom element that has not upgraded yet has no open() method, so
      // wait for whichever element is actually in the document.
      if (drawer && typeof drawer.open !== 'function') {
        await customElements.whenDefined(drawer.localName).catch(() => {});
      }

      if (typeof drawer?.open === 'function') {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
